import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/RCS-Logo-White.png";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../styles/Navbar.css';

const Navbar = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const isServicesActive = location.pathname.startsWith('/transport') ||
                            location.pathname.startsWith('/forwarding') ||
                            location.pathname.startsWith('/brokerage') ||
                            location.pathname.startsWith('/project');

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setMobileServicesOpen(false);
    }
  };

  const toggleMobileServices = () => {
    setMobileServicesOpen(!mobileServicesOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setMobileServicesOpen(false);
  };

  const formatDateTime = (date) =>
    date.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "Asia/Manila",
    });

  const [day, rest] = formatDateTime(dateTime).split(",");

  return (
    <>
      <nav className={`rcs-navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container-fluid px-4">
          <div className="d-flex justify-content-between align-items-center py-3">
            {/* Logo */}
            <Link to="/" className="d-flex align-items-center text-decoration-none">
              <img src={Logo} alt="RCS Logistics Philippines" className="rcs-logo" />
              <div className="ms-3 d-none d-sm-block">
                <h2 className="rcs-company-name">RCS LOGISTICS</h2>
                <p className="rcs-tagline">Your Trusted Shipping Partner</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="d-none d-lg-flex align-items-center">
              <Link to="/" className={`rcs-nav-link ${location.pathname === '/' ? 'active' : ''}`}>
                Home
              </Link>

              {/* Services Dropdown */}
              <div className="dropdown me-3" onMouseEnter={() => {}} onMouseLeave={() => {}}>
                <button
                  className={`rcs-services-btn dropdown-toggle ${isServicesActive ? 'active' : ''}`}
                  type="button"
                >
                  Services
                </button>
                <ul className="dropdown-menu rcs-dropdown">
                  <li><Link to="/transport" className="dropdown-item rcs-dropdown-item" onClick={handleLinkClick}>Transport Services</Link></li>
                  <li><Link to="/forwarding" className="dropdown-item rcs-dropdown-item" onClick={handleLinkClick}>Forwarding Services</Link></li>
                  <li><Link to="/brokerage" className="dropdown-item rcs-dropdown-item" onClick={handleLinkClick}>Brokerage Services</Link></li>
                  <li><Link to="/project" className="dropdown-item rcs-dropdown-item" onClick={handleLinkClick}>Project Services</Link></li>
                </ul>
              </div>

              <Link to="/gallery" className={`rcs-nav-link ${location.pathname === '/gallery' ? 'active' : ''}`}>
                Gallery
              </Link>

              <Link to="/aboutUs" className={`rcs-nav-link ${location.pathname === '/aboutUs' ? 'active' : ''}`}>
                About Us
              </Link>

              <Link to="/team" className={`rcs-nav-link ${location.pathname === '/team' ? 'active' : ''}`}>
                Management Team
              </Link>

              <a href="https://rcsphtracking.com" target="_blank" rel="noopener noreferrer" className="rcs-nav-link">
                Track Shipment
              </a>
            </div>

            {/* Right Section */}
            <div className="d-flex align-items-center">
              {/* Date Time */}
              <div className="d-none d-md-block me-4">
                <div className="rcs-datetime">{day}</div>
                <div className="rcs-datetime-sub">{rest}</div>
              </div>

              {/* Mobile Date Time */}
              <div className="d-md-none me-3">
                <div className="rcs-datetime" style={{ fontSize: '13px' }}>{day}</div>
                <div className="rcs-datetime-sub" style={{ fontSize: '11px' }}>{rest}</div>
              </div>

              {/* Contact Button - Desktop/Tablet Only */}
              <Link to="/contactUs" className="rcs-contact-btn me-3 d-none d-md-block">
                <i className="fas fa-envelope"></i>
                <span>Contact Us</span>
              </Link>

              {/* Mobile Menu Button */}
              <div className="d-lg-none">
                <button onClick={toggleMenu} className="rcs-mobile-menu-btn">
                  {isOpen ? (
                    <i className="fas fa-times" style={{ fontSize: '24px', color: 'white' }}></i>
                  ) : (
                    <i className="fas fa-bars" style={{ fontSize: '20px', color: 'white' }}></i>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          <div className={`rcs-mobile-navbar ${isOpen ? 'open' : ''} ${mobileServicesOpen ? 'services-open' : ''}`}>
            <div className="d-flex flex-column">
              <Link to="/" className={`rcs-mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={handleLinkClick}>
                <span className="nav-dot"></span>
                <span>Home</span>
              </Link>

              {/* Mobile Services */}
              <div>
                <button onClick={toggleMobileServices} className={`rcs-mobile-services-btn ${isServicesActive ? 'active' : ''}`}>
                  <div className="d-flex align-items-center">
                    <span className="nav-dot"></span>
                    <span>Services</span>
                  </div>
                  <i className={`fas fa-chevron-${mobileServicesOpen ? 'up' : 'down'}`}></i>
                </button>
                
                <div className={`rcs-mobile-services-dropdown ${mobileServicesOpen ? 'open' : ''}`}>
                  <Link to="/transport" className={`rcs-mobile-service-item ${location.pathname === '/transport' ? 'active' : ''}`} onClick={handleLinkClick}>
                    <span className="service-dot"></span>
                    Transport Services
                  </Link>
                  <Link to="/forwarding" className={`rcs-mobile-service-item ${location.pathname === '/forwarding' ? 'active' : ''}`} onClick={handleLinkClick}>
                    <span className="service-dot"></span>
                    Forwarding Services
                  </Link>
                  <Link to="/brokerage" className={`rcs-mobile-service-item ${location.pathname === '/brokerage' ? 'active' : ''}`} onClick={handleLinkClick}>
                    <span className="service-dot"></span>
                    Brokerage Services
                  </Link>
                  <Link to="/project" className={`rcs-mobile-service-item ${location.pathname === '/project' ? 'active' : ''}`} onClick={handleLinkClick}>
                    <span className="service-dot"></span>
                    Project Services
                  </Link>
                </div>
              </div>

              <Link to="/gallery" className={`rcs-mobile-nav-link ${location.pathname === '/gallery' ? 'active' : ''}`} onClick={handleLinkClick}>
                <span className="nav-dot"></span>
                <span>Gallery</span>
              </Link>

              <Link to="/aboutUs" className={`rcs-mobile-nav-link ${location.pathname === '/aboutUs' ? 'active' : ''}`} onClick={handleLinkClick}>
                <span className="nav-dot"></span>
                <span>About Us</span>
              </Link>

              <Link to="/team" className={`rcs-mobile-nav-link ${location.pathname === '/team' ? 'active' : ''}`} onClick={handleLinkClick}>
                <span className="nav-dot"></span>
                <span>Management Team</span>
              </Link>

              <a href="https://rcsphtracking.com" target="_blank" rel="noopener noreferrer" className="rcs-mobile-nav-link" onClick={handleLinkClick}>
                <span className="nav-dot"></span>
                <span>Track Shipment</span>
              </a>

              <Link to="/contactUs" onClick={handleLinkClick} className="rcs-mobile-contact-btn">
                <i className="fas fa-envelope"></i>
                <span>Contact Us</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="rcs-navbar-spacer"></div>
    </>
  );
};

export default Navbar;
